import { useEffect } from "react";
import { useLocation } from "react-router-dom";

type ScrollToProps = {
  x?: number;
  y?: number;
};

const ScrollTo = ({ x = 0, y = 0 }: ScrollToProps) => {
  const location = useLocation();
  const { pathname } = location;
  // scroll to x,y on change path
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(x, y);
    }, 50);
  }, [pathname, x, y]);
  return null;
};

export default ScrollTo;
